// Mobile Menu Toggle
const menuToggle = document.getElementById('menu-toggle');
const closeMenu = document.getElementById('close-menu');
const mobileMenu = document.getElementById('mobile-menu');
const mobileMenuLinks = document.querySelectorAll('#mobile-menu a');

menuToggle.addEventListener('click', () => {
    mobileMenu.classList.remove('translate-x-full');
});

closeMenu.addEventListener('click', () => {
    mobileMenu.classList.add('translate-x-full');
});

mobileMenuLinks.forEach(link => {
    link.addEventListener('click', () => {
        mobileMenu.classList.add('translate-x-full');
    });
});

// NEW: Test questions data based on archetypes
const questions = [{
    id: 1,
    question: "Wenn du einen Raum voller Menschen betrittst, dann …",
    options: [{
        text: "… spüren die anderen sofort meine stille Präsenz – Blicke bleiben an mir hängen.",
        archetype: "Diva"
    }, {
        text: "… wirke ich zunächst sanft und charmant – doch schnell merken die Menschen, dass mehr in mir steckt.",
        archetype: "Genießerin"
    }, {
        text: "… sehe ich mir aufmerksam an, wer hier Einfluss hat – und wie ich selbst die Dynamik lenken kann.",
        archetype: "Strategin"
    }, {
        text: "… falle ich mit meiner unkonventionellen Art auf – und genau das macht mich unverwechselbar.",
        archetype: "Rebellin"
    }],
    imageSrc: "{{ 'femme_fatale_test_01.jpg' | asset_url }}"
}, {
    id: 2,
    question: "Welches Kompliment trifft am meisten auf dich zu?",
    options: [{
        text: "„Deine Gedanken verführen mehr als jedes Lächeln.“",
        archetype: "Intellektuelle"
    }, {
        text: "„Mit dir wird selbst ein Umweg zur schönsten Erinnerung.“",
        archetype: "Abenteurerin"
    }, {
        text: "„Du sprudelst vor Ideen – niemand überrascht so wie du.“",
        archetype: "Chaotin"
    }, {
        text: "„Du bist das Geheimnis, das niemand ganz entschlüsseln kann.“",
        archetype: "Diva"
    }],
    imageSrc: "{{ 'femme_fatale_test_02.jpg' | asset_url }}"
}, {
    id: 3,
    question: "Wie bist du beim Flirten?",
    options: [{
        text: "Ich liebe das Spiel – aber nur, solange ich die Regeln bestimme.",
        archetype: "Strategin"
    }, {
        text: "Ich genieße das Knistern – und verschwinde gern, bevor es alltäglich wird.",
        archetype: "Abenteurerin"
    }, {
        text: "Ich flirte selten aktiv – meine Haltung fordert heraus, sich um mich zu bemühen.",
        archetype: "Diva"
    }, {
        text: "Oft überrascht es mich selbst, wie spontan und unberechenbar ich dabei werde.",
        archetype: "Chaotin"
    }],
    imageSrc: "{{ 'femme_fatale_test_03.jpg' | asset_url }}"
}, {
    id: 4,
    question: "Was ist dir in Beziehungen wichtig?",
    options: [{
        text: "Ich will inspiriert werden – Nähe darf mich nie fesseln.",
        archetype: "Rebellin"
    }, {
        text: "Ich brauche gute Gespräche und tiefe Gedanken.",
        archetype: "Intellektuelle"
    }, {
        text: "Ich brauche Nähe, die leicht und spielerisch bleibt, ohne an Magie zu verlieren.",
        archetype: "Genießerin"
    }, {
        text: "Ich brauche Nähe, die auch Distanz aushält – denn Geheimnisse gehören dazu.",
        archetype: "Diva"
    }],
    imageSrc: "{{ 'femme_fatale_test_04.jpg' | asset_url }}"
}, {
    id: 5,
    question: "Was bedeutet „Macht“ für dich?",
    options: [{
        text: "Mit klugen Ideen und Gedanken andere zu leiten.",
        archetype: "Intellektuelle"
    }, {
        text: "Das Spiel so zu lenken, dass es wie Zufall aussieht.",
        archetype: "Strategin"
    }, {
        text: "Erwartungen zu brechen – und gerade darin frei zu sein.",
        archetype: "Rebellin"
    }, {
        text: "Sinnliche Verführung so einzusetzen, dass man ihr nicht widerstehen kann.",
        archetype: "Genießerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_05.jpg' | asset_url }}"
}, {
    id: 6,
    question: "Wenn andere dich kritisieren, dann …",
    options: [{
        text: "„Zu distanziert? Distanz ist mein Geheimnis – und mein Zauber.“",
        archetype: "Diva"
    }, {
        text: "„Zu chaotisch? Genau daraus entsteht meine Magie.“",
        archetype: "Chaotin"
    }, {
        text: "„Zu berechnend? Ich nenne es: weitsichtig.“",
        archetype: "Strategin"
    }, {
        text: "„Zu rastlos? Rastlosigkeit ist Bewegung – und Bewegung ist mein Leben.“",
        archetype: "Abenteurerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_06.jpg' | asset_url }}"
}, {
    id: 7,
    question: "Wenn dich jemand unterschätzt …",
    options: [{
        text: "… bleibe ich charmant – und merke es mir.",
        archetype: "Strategin"
    }, {
        text: "… drehe ich den Spieß um – und zeige mit einem Augenzwinkern, dass ich weit mehr bin, als sie erwartet haben.",
        archetype: "Rebellin"
    }, {
        text: "… schweige ich – und es ist mir gleichgültig, denn ich weiß, was ich wert bin.",
        archetype: "Diva"
    }, {
        text: "… genieße ich es, wenn sie zu spät merken, dass hinter meiner Leichtigkeit mehr Tiefe steckt, als sie je vermutet hätten.",
        archetype: "Genießerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_07.jpg' | asset_url }}"
}, {
    id: 8,
    question: "Was würdest du an einem spontan freien Tag für dich tun?",
    options: [{
        text: "In ein anspruchsvolles Buch eintauchen, schreiben, nachdenken – einfach in meiner eigenen Welt versinken.",
        archetype: "Intellektuelle"
    }, {
        text: "Ein Fest nur für mich: Kochen, ein Bad nehmen, gute Musik – ein Tag voller Genuss.",
        archetype: "Genießerin"
    }, {
        text: "Endlich all die Dinge anreißen, die ich schon lange ausprobieren wollte – malen, zeichnen, schreiben … wo fange ich bloß an?",
        archetype: "Chaotin"
    }, {
        text: "Spontan losfahren – eine neue Stadt erkunden, in eine ungewöhnliche Ausstellung gehen oder neue Leute kennenlernen.",
        archetype: "Abenteurerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_08.jpg' | asset_url }}"
}, {
    id: 9,
    question: "Wie definierst du Sinnlichkeit?",
    options: [{
        text: "Ein tiefgründiges Gespräch, ein kluger Film oder ein gutes Buch – wenn Gedanken selbst berühren.",
        archetype: "Intellektuelle"
    }, {
        text: "Sinnlichkeit bedeutet, Spannung zu erschaffen – mit Nähe, die Fragen offenlässt.",
        archetype: "Diva"
    }, {
        text: "Sinnlichkeit entsteht, wenn man nicht nach den Regeln spielt, sondern sich selbst überrascht – indem man neue Rollen ausprobiert.",
        archetype: "Rebellin"
    }, {
        text: "Wenn alles fließt: Kunst, Wein, Musik – ein Rausch für alle Sinne.",
        archetype: "Genießerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_08.jpg' | asset_url }}"
}, {
    id: 10,
    question: "Welche Versuchung reizt dich am meisten?",
    options: [{
        text: "Etwas zu tun, das niemand von mir erwartet – nicht einmal ich selbst.",
        archetype: "Rebellin"
    }, {
        text: "Spontan eine verbotene Reise ins Unbekannte starten – und wirklich Neues erleben.",
        archetype: "Abenteurerin"
    }, {
        text: "Ein kluges Gespräch, das meine Gedanken herausfordert und mich tiefer blicken lässt.",
        archetype: "Intellektuelle"
    }, {
        text: "Ein Abend, der meine Kreativität entfesselt – voller Ideen, Bilder und neuer Inspiration.",
        archetype: "Chaotin"
    }],
    imageSrc: "{{ 'femme_fatale_test_10.jpg' | asset_url }}"
}, {
    id: 11,
    question: "Was sind deine häufigsten Stolpersteine?",
    options: [{
        text: "… wenn ich zu viel analysiere – und dabei das Fühlen vergesse.",
        archetype: "Strategin"
    }, {
        text: "… wenn ich glaube, alles kontrollieren zu müssen – als gäbe das Sicherheit.",
        archetype: "Diva"
    }, {
        text: "… wenn ich mich überreden lasse, statt meiner eigenen Lust zu folgen.",
        archetype: "Genießerin"
    }, {
        text: "… wenn ich wieder zu spät losfahre – verstrickt in tausend Dinge, die mich beschäftigen.",
        archetype: "Chaotin"
    }],
    imageSrc: "{{ 'femme_fatale_test_11.jpg' | asset_url }}"
}, {
    id: 12,
    question: "Wann fühlst du dich am lebendigsten?",
    options: [{
        text: "Wenn mein Chaos in Fluss gerät – und daraus plötzlich etwas Schönes entsteht.",
        archetype: "Chaotin"
    }, {
        text: "Wenn ich Grenzen sprenge – und dabei Seiten entdecke, die selbst mir neu sind.",
        archetype: "Rebellin"
    }, {
        text: "Wenn ich losfahre, ohne Ziel – und mich den Überraschungen des Lebens überlasse.",
        archetype: "Abenteurerin"
    }, {
        text: "Wenn mein Plan aufgeht – und niemand bemerkt, dass ich die Fäden in der Hand hatte.",
        archetype: "Strategin"
    }],
    imageSrc: "{{ 'femme_fatale_test_12.jpg' | asset_url }}"
}, {
    id: 13,
    question: "Welcher Satz passt am besten zu dir?",
    options: [{
        text: "„Ich bin nicht kompliziert – ich bin nur nicht simpel.“",
        archetype: "Intellektuelle"
    }, {
        text: "„Ich weiß, wie man wirklich in vollen Zügen genießt.“",
        archetype: "Genießerin"
    }, {
        text: "„Ich lasse mich nicht in Rollen zwängen – ich schreibe mein eigenes Stück.“",
        archetype: "Rebellin"
    }, {
        text: "„Eine Frau ohne Geheimnisse ist wie eine Blume ohne Duft.“",
        archetype: "Diva"
    }],
    imageSrc: "{{ 'femme_fatale_test_13.jpg' | asset_url }}"
}, {
    id: 14,
    question: "Wie gehst du mit Männern um, wenn du ihre Aufmerksamkeit willst?",
    options: [{
        text: "Ich fordere sie heraus – indem ich genau das tue, was man von mir nicht erwartet.",
        archetype: "Rebellin"
    }, {
        text: "Ich lasse sie glauben, sie führen das Spiel – während ich längst die Zügel halte.",
        archetype: "Strategin"
    }, {
        text: "Ich überrasche sie durch meine Spontaneität – kein Treffen läuft so, wie sie es planen.",
        archetype: "Abenteurerin"
    }, {
        text: "Ich wirke unberechenbar – meine Kreativität macht sie neugierig, ohne dass sie wissen warum.",
        archetype: "Chaotin"
    }],
    imageSrc: "{{ 'femme_fatale_test_14.jpg' | asset_url }}"
}, {
    id: 15,
    question: "Wie reagieren Menschen oft auf dich?",
    options: [{
        text: "Sie fühlen sich inspiriert – ich bin der Funke, der Neues entzündet.",
        archetype: "Chaotin"
    }, {
        text: "Sie lassen sich gerne von meiner Wärme und Sinnlichkeit verführen.",
        archetype: "Genießerin"
    }, {
        text: "Sie fühlen sich verunsichert – weil sie mich nicht enträtseln können, und ich es ihnen nicht leicht mache.",
        archetype: "Diva"
    }, {
        text: "Viele fühlen sich beeindruckt – meine Souveränität wirkt stärker als Worte.",
        archetype: "Strategin"
    }],
    imageSrc: "{{ 'femme_fatale_test_15.jpg' | asset_url }}"
}, {
    id: 16,
    question: "Was ist für dich Luxus?",
    options: [{
        text: "Freiheit, die Tür zu öffnen und einfach zu gehen, wann immer mir danach ist.",
        archetype: "Abenteurerin"
    }, {
        text: "Ein wirklich spannender Austausch, bei dem Gedanken und Ideen viel tiefer führen als Smalltalk.",
        archetype: "Intellektuelle"
    }, {
        text: "Ein Tisch voller Köstlichkeiten, Kerzen, Wein – umgeben von Kunst und Schönheit.",
        archetype: "Genießerin"
    }, {
        text: "Der perfekte Auftritt – ein Outfit, ein Blick, und ich spiele die Hauptrolle in meinem eigenen Film.",
        archetype: "Diva"
    }],
    imageSrc: "{{ 'femme_fatale_test_16.jpg' | asset_url }}"
}, {
    id: 17,
    question: "Wenn du dich in einem Wort beschreiben müsstest …",
    options: [{
        text: "Unberechenbar.",
        archetype: "Rebellin"
    }, {
        text: "Genussvoll.",
        archetype: "Genießerin"
    }, {
        text: "Geheimnisvoll.",
        archetype: "Diva"
    }, {
        text: "Freiheitsliebend.",
        archetype: "Abenteurerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_17.jpg' | asset_url }}"
}, {
    id: 18,
    question: "Was bleibt von dir, wenn du gehst?",
    options: [{
        text: "Ein kluger Gedanke, der nachhallt.",
        archetype: "Intellektuelle"
    }, {
        text: "Ein Hauch von Rätsel und Eleganz.",
        archetype: "Diva"
    }, {
        text: "Ein kreativer Funke, der auf andere überspring und Neues entfacht.",
        archetype: "Chaotin"
    }, {
        text: "Ein Gefühl von Freiheit – und der Mut, den eigenen Weg zu gehen.",
        archetype: "Abenteurerin"
    }],
    imageSrc: "{{ 'femme_fatale_test_18.jpg' | asset_url }}"
}];


// NEW: 7 result archetypes with detailed descriptions
const resultTypes = {
    "Genießerin": {
        title: "Sweet Until Dangerous – Die sinnliche Genießerin",
        imageSrc: "{{ '1-femme-fatale-archetyp-sinnliche-geniesserin.jpg' | asset_url }}",
        strength: "Du verzauberst mit Wärme, Stil und Genuss. Du hast ein feines Gespür für Stimmungen – und weißt, wie man mit kleinen Gesten große Wirkung erzielt. Menschen fühlen sich in deiner Nähe geborgen und inspiriert. Dein Sinn für Schönheit macht dich selbst zu einem lebendigen Kunstwerk.",
        shadow: "Manchmal wirkst du harmlos – bis andere merken, dass du unterschwellig die Fäden in der Hand hältst. Dein Charme kann so süß sein, dass man erst später bemerkt, wie viel Macht darin steckt.",
        strategy: "Du arbeitest mit Wärme, Nähe und Genuss: kleine Aufmerksamkeiten, ein wohlgesetzter Blick, eine köstliche Verführung — und Menschen folgen dir, weil sie sich wohl und gesehen fühlen.",
        tip: "Nutze diese Gabe, um Verbundenheit zu schaffen — nicht um Menschen auszunutzen. Ehrliche Verführung wirkt am stärksten.",
        development: "Lass andere deine Tiefe bewusst spüren – nicht nur deine Leichtigkeit. Verfeinere die Kunst, „Nein“ zu sagen, ohne deine Wärme zu verlieren. Und gönn dir den Luxus, nicht nur andere zu verführen, sondern dich auch selbst."
    },
    "Chaotin": {
        title: "Reflected Dreams – Die kreative Chaotin",
        imageSrc: "{{ '2-femme-fatale-archetyp-kreative-chaotin.jpg' | asset_url }}",
        strength: "Du bist ein Feuerwerk aus Ideen, Farben und Emotionen. Dein Charme liegt in deiner Spontaneität – du bringst Bewegung und Lebendigkeit in jedes Umfeld. Dein Chaos ist oft die Quelle von kleinen Wundern. In deinem Leben gleicht jeder Tag einer Leinwand, die du spontan neu bemalst.",
        shadow: "Manchmal verzettelst du dich in deinen vielen Ideen, und andere sehen in dir eher ein Rätsel als eine Verlässlichkeit. Dein unvorhersehbares Temperament kann ebenso faszinieren wie irritieren.",
        strategy: "Du überwältigst mit Reizüberfluss: neue Ideen, intensive Emotionen und überraschende Aktionen lenken die Aufmerksamkeit auf dich. Menschen nehmen dich als Quelle von Faszination wahr und folgen deinem Impuls.",
        tip: "Achte darauf, dass deine Impulse andere inspirieren — nicht überfordern. Eine klare Einladung ist oft wirksamer als Dauerüberraschung.",
        development: "Gib deinem Chaos hin und wieder eine Bühne – kleine Strukturen können deine Kreativität noch kraftvoller machen. Lerne, welche Ideen du ziehen lässt und welche du ins Leben bringst. Dein „kreatives Durcheinander“ ist ein Geschenk – wenn du es zu lenken weißt."
    },
    "Diva": {
        title: "Red Allure – Die glamouröse Diva",
        imageSrc: "{{ '3-femme-fatale-archetyp-glamouroese-diva.jpg' | asset_url }}",
        strength: "Du sprichst durch Blicke, nicht durch Worte. Deine Präsenz ist magnetisch, deine Distanz macht dich begehrenswert. Mit deinem Stil verwandelst du jedes Auftreten in eine Inszenierung – und bleibst unvergesslich. Du bist wie ein Gemälde, das man nicht vergisst, weil es mehr andeutet, als es zeigt.",
        shadow: "Deine Kühle kann andere verunsichern. Manchmal bist du so rätselhaft, dass Nähe schwerfällt. Wer dich nicht versteht, hält dich für unnahbar.",
        strategy: "Du manipulierst durch Andeutung: Stille, ein fehlendes Wort, ein lange gehaltener Blick — das Unausgesprochene zieht andere magisch an und lässt sie die Lücken füllen.",
        tip: "Nutze Andeutungen, um Interesse zu wecken, nicht um Menschen in Unsicherheit zu lassen. Ein winziger Hinweis schafft Vertrauen.",
        development: "Öffne punktuell den Vorhang: kleine Einblicke verstärken statt schwächen deine Wirkung. So wird Distanz zur Einladung, nicht zur Mauer."
    },
    "Rebellin": {
        title: "Backstage Secrets – Die stilvolle Rebellin",
        imageSrc: "{{ '4-femme-fatale-archetyp-stilvolle-rebellin.jpg' | asset_url }}",
        strength: "Du liebst es, Erwartungen zu brechen – und das mit Stil. Deine Unabhängigkeit inspiriert andere, ihren eigenen Weg zu gehen. Du bist das Fragezeichen, das Räume spannender macht. Deine Ausstrahlung erinnert an ein Kunstwerk, das provoziert und fasziniert – gerade weil es nicht jedem gefällt.",
        shadow: "Manchmal rebellierst du nur, um dich lebendig zu fühlen – selbst dann, wenn es gar keinen Widerstand braucht. Dein Nonkonformismus kann andere irritieren oder überfordern.",
        strategy: "Du provozierst gezielt: ein Tabubruch, eine ungewohnte Meinung, ein stilistisches Eigentor – und schon löst du Neugier und Diskussion aus. Deine Regeln-brechen-Ästhetik lenkt die Aufmerksamkeit dorthin, wo du sie haben willst.",
        tip: "Provokation ist kraftvoll — nutze sie, um Türen zu öffnen, nicht um Wunden von anderen zu vertiefen.",
        development: "Lerne, zwischen Rebellion aus Freiheit und Rebellion aus Trotz zu unterscheiden. Setze deine Andersartigkeit als Geschenk ein – nicht nur als Provokation. Deine Kraft liegt darin, Regeln neu zu schreiben, nicht nur sie zu brechen."
    },
    "Strategin": {
        title: "Queen of the Game – Die Strategin",
        imageSrc: "{{ '5-femme-fatale-archetyp-strategin.jpg' | asset_url }}",
        strength: "Du denkst drei Züge voraus – ob im Flirt, im Gespräch oder im Leben. Deine Klarheit ist ebenso scharf wie dein Charme. Du bist die Frau, die nicht spielt – sondern das Spiel gestaltet. Dein Charme gleicht einem Schachbrett aus Eleganz und Kunst – wohlüberlegt und zugleich verführerisch inszeniert.",
        shadow: "Deine Stärke kann als Berechnung missverstanden werden. Wer dir nicht gewachsen ist, fühlt sich leicht überrollt. Deine Kontrolle kann andere einschüchtern – und dich manchmal von echten Gefühlen distanzieren.",
        strategy: "Dein Werkzeug ist Inszenierung: du arrangierst Situationen, sprichst bewusst Andeutungen aus und lässt Entscheidungen aussehen wie freie Wahl — während du die Richtung vorgibst. Menschen handeln, weil sie glauben, sie hätten gewählt.",
        tip: "Führung ohne Täuschung wirkt nachhaltiger. Transparenz in der Intention schafft Respekt.",
        development: "Verfeinere die Kunst der strategischen Verletzlichkeit. Manchmal ist es machtvoller, bewusst loszulassen, als alles im Griff zu haben. Dein Spiel gewinnt an Tiefe, wenn auch Überraschung darin Platz findet."
    },
    "Intellektuelle": {
        title: "Between the Lines – Die Intellektuelle",
        imageSrc: "{{ '6-femme-fatale-archetyp-intellektuelle.jpg' | asset_url }}",
        strength: "Deine Gedanken sind geschliffen, deine Worte haben Gewicht. Du verführst nicht laut, sondern tief – durch deine Geschichten, deine Fragen, deine Art, zwischen den Zeilen zu lesen. Du bist wie ein literarisches Porträt – tiefgründig, klar gezeichnet und voller Zwischentöne.",
        shadow: "Manchmal verlierst du dich in Worten und Analysen. Deine Distanz kann andere einschüchtern, weil sie nicht wissen, was in dir vorgeht. Dein Kopf ist stark – manchmal stärker als dein Herz.",
        strategy: "Du führst mit Worten: ein gezielt gesetzter Satz, ein starkes Bild oder eine kluge Frage – und schon hören Menschen dir gebannt zu. Deine Stärke liegt darin, Sprache so einzusetzen, dass sie deine Position entscheidend stärkt. Manchmal aber überforderst du andere oder lässt sie kleiner und schwächer wirken, als sie sind.",
        tip: "Worte dürfen bewegen – achte darauf, dass sie klar bleiben und andere sich verstanden und mitgenommen fühlen, nicht ausgeschlossen.",
        development: "Lass öfter zu, dass Gefühle deine Worte führen. Teile deine Gedanken, ohne sie immer zu perfektionieren. Deine größte Kraft liegt in der Balance: klug, tief – und dabei spürbar menschlich."
    },
    "Abenteurerin": {
        title: "Midnight Driver – Die spontane Abenteurerin",
        imageSrc: "{{ '7-femme-fatale-archetyp-spontane-abenteuererin.jpg' | asset_url }}",
        strength: "Du bist die Heldin deines eigenen Roadmovies. Du liebst das Unbekannte, die Freiheit, das Kribbeln des Ungeplanten. Dein Mut steckt andere an und bringt Bewegung ins Leben. Du wirkst wie eine Protagonistin im Film Noir – immer unterwegs, geheimnisvoll, und das Lenkrad deines Lebens fest in der Hand.",
        shadow: "Manchmal bist du rastlos – ständig auf der Suche nach neuen Erfahrungen. Tiefe Verbindungen können dir schwerfallen, wenn Freiheit für dich über allem steht.",
        strategy: "Du verführst mit Versprechen: die Aussicht auf Freiheit, Abenteuer und das Gefühl, dass gleich etwas Neues beginnt. Andere lassen sich von deiner Energie anziehen, weil dein Leben wie ein offenes Kapitel wirkt, in dem sie unbedingt vorkommen wollen.",
        tip: "Versprich nur das, was du wirklich leben kannst. Freiheit ist unwiderstehlich – doch Ehrlichkeit macht sie noch wertvoller.",
        development: "Erkenne, dass Freiheit nicht verloren geht, wenn man Halt findet. Manchmal ist ein sicherer Hafen das Sprungbrett für noch größere Abenteuer. Dein Mut wächst, wenn du lernst, auch die Pause zu genießen."
    }
};

// Application state
let currentQuestionIndex = 0;
let userAnswers = [];

// DOM elements
const heroSection = document.getElementById('home');
const testSection = document.getElementById('test-section');
const testNavigation = document.getElementById('test-navigation');
const loadingSection = document.getElementById('loading-section');
const resultsSection = document.getElementById('results-section');
const startTestSectionBtn = document.getElementById('start-Test-section-btn');
const questionContainer = document.getElementById('question-container');
const questionCounter = document.getElementById('question-counter');
const progressPercentage = document.getElementById('progress-percentage');
const progressFill = document.getElementById('progress-fill');
const footerProgressFill = document.getElementById('footer-progress-fill');
const nextQuestionBtn = document.getElementById('next-question-btn');
const prevQuestionBtn = document.getElementById('prev-question-btn');
const TestStart = document.getElementById('Test-start');

// Helper function to scroll to an element
function scrollToElement(element) {
    const headerOffset = document.querySelector('nav').offsetHeight;
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}

// Fisher-Yates shuffle algorithm
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

// Start the test
startTestSectionBtn.addEventListener('click', function() {
    shuffleArray(questions);
    TestStart.classList.add('hidden');
    testSection.classList.remove('hidden');
    testNavigation.classList.remove('hidden');
    displayQuestion(currentQuestionIndex);
});

// Display a question
function displayQuestion(index) {
    const question = questions[index];
    questionCounter.textContent = `Frage ${index + 1} von ${questions.length}`;

    const progressPercent = Math.round(((index) / questions.length) * 100);
    progressPercentage.textContent = `${progressPercent}%`;
    progressFill.style.width = `${progressPercent}%`;
    footerProgressFill.style.width = `${progressPercent}%`;

    prevQuestionBtn.classList.toggle('hidden', index === 0);
    nextQuestionBtn.textContent = (index === questions.length - 1) ? 'Ergebnis anzeigen' : 'Nächste Frage';

    const shuffledOptions = [...question.options];
    shuffleArray(shuffledOptions);

    let questionHTML = `
        <div class="flex flex-col md:flex-row gap-8 items-start">
            <div class="w-full md:w-1/2 order-2 md:order-1">
                <div class="artwork-container bg-gray-100 rounded-lg overflow-hidden mb-4 relative group" data-img-src="${question.imageSrc}">
                    <img src="${question.imageSrc}" alt="Artwork for question" class="w-full h-auto">
                     <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all flex justify-center items-center">
                         <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white opacity-0 group-hover:opacity-75 transition-opacity" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" /></svg>
                    </div>
                </div>
                 <p class="text-sm text-gray-500">Klicke auf das Bild für die Vollansicht.</p>
            </div>
            <div class="w-full md:w-1/2 order-1 md:order-2">
                <h2 class="text-2xl md:text-3xl font-bold mb-6">${question.question}</h2>
                <div class="space-y-4">
    `;

    shuffledOptions.forEach(option => {
        const isSelected = userAnswers[index] === option.archetype;
        questionHTML += `
            <div class="option-card border-gray-300 bg-white p-4 rounded-lg flex items-center cursor-pointer border-2 hover:border-primary transition-all ${isSelected ? 'selected' : ''}" data-archetype="${option.archetype}">
                <div class="option-radio h-6 w-6 rounded-full border-2 border-gray-300 flex-shrink-0 mr-4 ${isSelected ? 'selected' : ''}"></div>
                <span class="option-text flex-grow ${isSelected ? 'selected' : ''}">${option.text}</span>
            </div>
        `;
    });

    questionHTML += `</div></div></div>`;
    questionContainer.innerHTML = questionHTML;

    // Add event listeners
    document.querySelector('.artwork-container').addEventListener('click', function() {
        openLightbox(this.dataset.imgSrc);
    });

    document.querySelectorAll('.option-card').forEach(card => {
        card.addEventListener('click', function() {
            userAnswers[currentQuestionIndex] = this.dataset.archetype;

            document.querySelectorAll('.option-card').forEach(c => c.classList.remove('selected'));
            this.classList.add('selected');

            setTimeout(() => nextQuestionBtn.click(), 300);
        });
    });
}

// Handle next question button
nextQuestionBtn.addEventListener('click', function() {
    if (userAnswers[currentQuestionIndex] === undefined) {
        alert('Bitte wähle eine Antwort, bevor Du fortfährst.');
        return;
    }

    if (currentQuestionIndex < questions.length - 1) {
        currentQuestionIndex++;
        displayQuestion(currentQuestionIndex);
        scrollToElement(testSection);
        questionContainer.classList.add('fade-in');
        setTimeout(() => questionContainer.classList.remove('fade-in'), 500);
    } else {
        testSection.classList.add('hidden');
        testNavigation.classList.add('hidden');
        loadingSection.classList.remove('hidden');
        
        // Start loading animation
        const loadingBar = document.getElementById('loading-bar');
        const loadingPercentage = document.getElementById('loading-percentage');
        const archetypeFlicker = document.getElementById('archetype-flicker');
        const archetypeTitles = Object.values(resultTypes).map(r => r.title);
        let progress = 0;

        const interval = setInterval(() => {
            progress += 2;
            loadingBar.style.width = `${progress}%`;
            loadingPercentage.textContent = `${progress}%`;

            // Flicker archetype titles
            const randomTitle = archetypeTitles[Math.floor(Math.random() * archetypeTitles.length)];
            archetypeFlicker.textContent = randomTitle;
            archetypeFlicker.style.animation = 'flicker 0.2s ease-in-out';
            setTimeout(() => {
                archetypeFlicker.style.animation = '';
            }, 200);

            if (progress >= 100) {
                clearInterval(interval);
                const resultArchetype = calculateResults();
                setTimeout(() => {
                    loadingSection.classList.add('hidden');
                    resultsSection.classList.remove('hidden');
                    displayResults(resultArchetype);
                    scrollToElement(resultsSection);
                }, 500); // Short delay after loading is complete
            }
        }, 50); // Adjust timing for speed
    }
});

// Handle previous question button
prevQuestionBtn.addEventListener('click', function() {
    if (currentQuestionIndex > 0) {
        currentQuestionIndex--;
        displayQuestion(currentQuestionIndex);
        scrollToElement(testSection);
        questionContainer.classList.add('fade-in');
        setTimeout(() => questionContainer.classList.remove('fade-in'), 500);
    }
});

// Calculate test results
function calculateResults() {
    const counts = {};
    userAnswers.forEach(archetype => {
        counts[archetype] = (counts[archetype] || 0) + 1;
    });

    // Find the archetype with the highest count
    let maxCount = 0;
    let resultArchetype = "";
    for (const archetype in counts) {
        if (counts[archetype] > maxCount) {
            maxCount = counts[archetype];
            resultArchetype = archetype;
        }
    }
    return resultArchetype;
}

// Display results
function displayResults(archetypeKey) {
    const result = resultTypes[archetypeKey];

    if (!result) {
        console.error('Kein Ergebnis für diesen Archetyp gefunden:', archetypeKey);
        window.location.href = window.location.pathname; // Reload on error
        return;
    }

    document.getElementById('result-title').textContent = result.title;

    // Set result image and lightbox functionality
    const resultImageContainer = document.getElementById('result-image-container');
    const resultImage = document.getElementById('result-image');
    resultImage.src = result.imageSrc;
    resultImage.alt = `Dein Femme Fatale Archetyp: ${result.title}`;
    resultImageContainer.dataset.imgSrc = result.imageSrc;
    resultImageContainer.addEventListener('click', () => openLightbox(result.imageSrc));

    document.getElementById('result-strength').innerHTML = `<h3 class="text-xl font-semibold mb-2 text-primary">Deine Stärke</h3><p>${result.strength}</p>`;
    document.getElementById('result-shadow').innerHTML = `<h3 class="text-xl font-semibold mb-2 text-primary">Schattenaspekte</h3><p>${result.shadow}</p>`;
    document.getElementById('result-strategy').innerHTML = `<h3 class="text-xl font-semibold mb-2 text-primary">Deine Manipulationsstrategie</h3><p>${result.strategy}</p>`;
    document.getElementById('result-tip').innerHTML = `<h3 class="text-xl font-semibold mb-2 text-primary">Ein Tipp</h3><p>${result.tip}</p>`;
    document.getElementById('result-development').innerHTML = `<h3 class="text-xl font-semibold mb-2 text-primary">Deine Entwicklungsmöglichkeiten</h3><p>${result.development}</p>`;

    // Share functionality (optional, can be adapted)
    const shareBtn = document.getElementById('share-result-btn');
    const shareModal = document.getElementById('share-modal');
    const closeShareModal = document.getElementById('close-share-modal');
    const copyLinkBtn = document.getElementById('copy-link');
    const shareLinkInput = document.getElementById('share-link');

    const baseUrl = window.location.origin + window.location.pathname;
    const resultUrl = `${baseUrl}?result=${archetypeKey}`;
    const shareText = encodeURIComponent(`Ich bin: ${result.title}! Entdecke auch du deine innere Femme Fatale:`);

    shareLinkInput.value = resultUrl;
    document.getElementById('share-facebook').href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(resultUrl)}`;
    document.getElementById('share-twitter').href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(resultUrl)}&text=${shareText}`;
    document.getElementById('share-whatsapp').href = `https://api.whatsapp.com/send?text=${shareText} ${encodeURIComponent(resultUrl)}`;
    document.getElementById('share-telegram').href = `https://t.me/share/url?url=${encodeURIComponent(resultUrl)}&text=${shareText}`;
    
    shareBtn.onclick = () => shareModal.classList.remove('hidden');
    closeShareModal.onclick = () => shareModal.classList.add('hidden');
    
    copyLinkBtn.onclick = () => {
        shareLinkInput.select();
        document.execCommand('copy');
        copyLinkBtn.textContent = 'Kopiert!';
        setTimeout(() => { copyLinkBtn.textContent = 'Kopieren'; }, 2000);
    };
    
    window.onclick = (event) => {
        if (event.target == shareModal) {
            shareModal.classList.add('hidden');
        }
    };
}


// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId.length > 1 && document.querySelector(targetId)) {
            e.preventDefault();
            const target = document.querySelector(targetId);
            scrollToElement(target);
        }
    });
});

// Event Listener for "Test wiederholen"
document.getElementById('restart-Test').addEventListener('click', () => {
    currentQuestionIndex = 0;
    userAnswers = [];
    resultsSection.classList.add('hidden');
    document.getElementById('Test-start').classList.remove('hidden');
    window.history.pushState({}, '', window.location.pathname);
    scrollToElement(document.getElementById('Test'));
});

// Check for result parameter in URL on page load
window.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const resultFromUrl = params.get('result');
    if (resultFromUrl && resultTypes[resultFromUrl]) {
        TestStart.classList.add('hidden');
        resultsSection.classList.remove('hidden');
        displayResults(resultFromUrl);
        scrollToElement(resultsSection);
    }
});

// Lightbox controls
const lightboxOverlay = document.getElementById('lightbox-overlay');
const lightboxImage = document.getElementById('lightbox-image');
const lightboxClose = document.getElementById('lightbox-close');

function openLightbox(src) {
    lightboxImage.setAttribute('src', src);
    lightboxOverlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
}

function closeLightbox() {
    lightboxOverlay.classList.add('hidden');
    document.body.style.overflow = '';
}

lightboxClose.addEventListener('click', closeLightbox);
lightboxOverlay.addEventListener('click', function(event) {
    if (event.target === lightboxOverlay) {
        closeLightbox();
    }
});